import React, { useContext, useState, ReactNode } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import PerformanceSummary from './PerformanceSummary';
import View from './View';
import Concerts from 'pages/Entity/Track/Shared/Concerts';
import Physical from '../Overview/Physical';

import { overviewSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext, SalesTypes } from 'context/entityContext';

const Overview: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix, artistMetadata } = props;
  const { entities } = match.params;

  const { compareMode, entityType, topic } = useContext(EntityContext);

  const [selectedSalesType, setSelectedSalesType] = useState<SalesTypes>();

  return (
    <>
      <SubNavigation topic="overview" variants={overviewSubTopics} />
      <TopicFilters
        topic={topic[1] || topic[0]}
        compareMode={compareMode}
        selectedSalesType={selectedSalesType}
        entityType={entityType}
      />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/project/${entities}/overview/summary`}
          render={(): ReactNode => <PerformanceSummary />}
        />
        <Route
          exact
          path={`${pathPrefix}/project/${entities}/overview/view`}
          render={(): any => (
            <View setSelectedSalesType={setSelectedSalesType} />
          )}
        />
        <Redirect
          exact
          from={`${pathPrefix}/project/${entities}/overview/certifications`}
          to={`${pathPrefix}/project/${entities}/overview/summary`}
        />
        <Route
          exact
          path={`${pathPrefix}/project/${entities}/overview/concerts`}
          render={(): any => (
            <Concerts
              topic={topic.join('/')}
              artist={{
                entityType: artistMetadata?.type,
                entityId: artistMetadata?.id,
                name: artistMetadata?.displayName,
              }}
              compareMode={compareMode}
            />
          )}
        />
        <Route
          exact
          path={`${pathPrefix}/project/${entities}/overview/physical`}
          render={(): ReactNode => <Physical />}
        />
      </Switch>
    </>
  );
};

export default Overview;
